<template>
  <div class="holder">
    <h4 class="font-weight-light blue-grey--text text--lighten-5">
      {{ $t("project_file_upload.upload_only_specify") }}
    </h4>
    <h5 class="font-weight-light blue-grey--text text--lighten-1">
      {{ $t("project_file_upload.file_size") }}<br />
      {{ $t("project_file_upload.detail") }}
    </h5>
    <div>
      <v-row>
        <v-col cols="12" md="2">
          <v-btn
            dense
            small
            elevation="0"
            color="light-blue lighten-2"
            @click="open_upload_dialog()"
          >
            {{ $t("project_file_upload.upload_file") }}
          </v-btn>
        </v-col>
        <v-col cols="12" md="10">
          <div class="file_holder">
            <span class="white--text ml-3"
              >{{ $t("project_file_upload.uploaded_file") }} :
            </span>
            <span v-if="!has_file" class="white--text">{{
              $t("project_file_upload.no_file_uploaded")
            }}</span>
            <span v-if="has_file" class="white--text">
              <a
                target="blank"
                :href="file_path + project_item.REGISTER_ID"
                style="text-decoration: none"
              >
                <v-btn x-small color="white" outlined class="ml-2">{{
                  $t("project_file_upload.view")
                }}</v-btn>
              </a>
              <v-btn
                x-small
                color="red"
                outlined
                class="ml-2"
                @click="open_delete_dialog()"
                >{{ $t("project_file_upload.delete") }}</v-btn
              >
            </span>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-dialog max-width="600px" v-model="dialog_open_status">
      <v-card>
        <v-card-title
          :class="mode === 'upload' ? 'light-blue lighten-2' : 'red'"
        >
          <span v-if="mode === 'upload'">{{
            $t("officer_config.attach_PDF_if_any")
          }}</span>
          <span v-if="mode === 'delete'">{{
            $t("officer_config.delete_file")
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-file-input
            v-if="mode === 'upload'"
            v-model="pdf_file"
            :label="$t('officer_config.attach_PDF_if_any')"
          ></v-file-input>
          <div v-if="mode === 'delete'" class="mt-5">
            {{ $t("project_file_upload.confirm_delete_file") }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            dark
            color="light-blue lighten-2"
            elevation="1"
            @click="upload()"
            v-if="mode === 'upload'"
          >
            {{ $t("project_file_upload.upload") }}
          </v-btn>
          <v-btn
            dark
            color="red"
            elevation="1"
            @click="confirm_delete()"
            v-if="mode === 'delete'"
          >
            {{ $t("officer_config.delete_file") }}
          </v-btn>
          <v-btn outlined color="red" @click="dialog_open_status = false">{{
            $t("confirm_regis.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApplicantInfoProvider from "@/services/applicant_info";

const applicantInfoService = new ApplicantInfoProvider();

export default {
  name: "projectFileUpload",
  props: {
    project_item: {
      type: Object,
    },
    fetch: {
      type: Function,
    },
  },
  data: () => ({
    mode: null,
    dialog_open_status: false,
    pdf_file: null,
    loading: false,
  }),
  computed: {
    has_file() {
      return this.project_item.ADDITIONAL_FILE === "1";
    },
    file_path() {
      return (
        process.env.VUE_APP_ENDPOINT +
        "admission/api/" +
        "?function=get-document-file&service_type=register&" +
        "response_type=file&REGISTER_ID="
      );
    },
  },
  methods: {
    open_upload_dialog() {
      this.mode = "upload";
      this.dialog_open_status = true;
    },
    open_delete_dialog() {
      this.mode = "delete";
      this.dialog_open_status = true;
    },
    async upload() {
      if (this.pdf_file) {
        this.loading = true;
        let upload_response = await applicantInfoService
          .uploadRegisterFile({
            FILE: this.pdf_file,
            REGISTER_ID: this.project_item.REGISTER_ID,
          })
          .catch((error) => {
            this.loading = false;
            this.$toasted.error(JSON.stringify(error.response.data.message), { duration: 0 });
          });
        if (upload_response && upload_response.status) {
          this.dialog_open_status = false;
          this.fetch();
          this.$toasted.success(this.$t("toasted.create_successfully"));
        }
      }
    },
    async confirm_delete() {
      this.loading = true;
      let response = await applicantInfoService
        .deleteRegisterFile({
          REGISTER_ID: this.project_item.REGISTER_ID,
        })
        .catch((error) => {
          this.loading = false;
          this.$toasted.error(JSON.stringify(error.response.data.message), { duration: 0 });
        });
      if (response && response.status) {
        this.dialog_open_status = false;
        this.fetch();
        this.$toasted.success(this.$t("toasted.delete_successfully"));
      }
    },
  },
};
</script>

<style scoped>
.holder {
  border-width: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: #039be5;
  padding: 6px;
  background-color: rgb(0, 33, 48);
}
.file_holder {
  border-width: 0px;
  border-radius: 5px;
  border-style: solid;
  border-color: #00a336;
  padding: 8px;
  /* background-color: rgb(0, 36, 22); */
}
</style>
